import React from "react";

interface DashboardHeaderProps {
  title: string;
  subtitle: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
  backgroundClassName?: string;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title,
  subtitle,
  action,
  children,
  backgroundClassName = "bg-gradient-to-r from-primary/10 to-accent/5"
}) => {
  return (
    <div
      className={`relative ${backgroundClassName} rounded-2xl shadow-xl p-8 mb-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6 overflow-hidden border border-[#b1c3cf]/40`}
      style={{ minHeight: "120px" }}
    >
      <div className="flex-1 flex flex-col gap-2">
        <h1 className="text-4xl md:text-5xl font-extrabold font-title text-primary mb-1 tracking-tight leading-tight">
          {title}
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground font-serif font-normal">
          {subtitle}
        </p>
        {children && <div className="mt-2">{children}</div>}
      </div>
      {action && (
        <div className="flex-shrink-0 flex justify-end items-center mt-6 md:mt-0">
          {action}
        </div>
      )}
    </div>
  );
}; 